import React from "react";
import { Card, Col } from "antd";
import {
  TeamOutlined,
  FunctionOutlined,
  MailOutlined,
  SnippetsOutlined,
} from "@ant-design/icons";
import "./counts.css";

const Counts = ({ counts }) => {
  const count = [
    {
      label: "Total Experts",
      value: counts?.totalExperts ?? 0,
      icon: <TeamOutlined />,
      meta: "Talent capacity",
    },
    {
      label: "Tech & Tools",
      value: counts?.uniqueTechAndToolsCount ?? 0,
      icon: <FunctionOutlined />,
      meta: "Unique stack signals",
    },
    {
      label: "Inquiries",
      value: counts?.inquiriesTotal ?? 0,
      icon: <MailOutlined />,
      meta: "Active demand flow",
    },
    {
      label: "Subscribers",
      value: counts?.newsletterSubscribers ?? 0,
      icon: <SnippetsOutlined />,
      meta: "Audience retention",
    },
  ];

  return (
    <>
      {count.map((c, index) => (
        <Col key={index} xs={24} sm={12} lg={12} xl={6}>
          <Card bordered={false} className="admin-kpi-card">
            <div className="admin-kpi">
              <div className="admin-kpi__topline">
                <span className="admin-kpi__label">{c.label}</span>
                <span className="admin-kpi__chip">Live</span>
              </div>
              <div className="admin-kpi__meta">
                <span className="admin-kpi__value">{c.value}</span>
                <div className="admin-kpi__icon">{c.icon}</div>
              </div>
              <span className="admin-kpi__meta">{c.meta}</span>
            </div>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default Counts;
